var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-row',[_c('vs-col',{attrs:{"vs-w":"12"}},[_c('div',{staticClass:"widget-card-header-style"},[_vm._v(_vm._s(_vm._f("capitalize")(_vm.title)))])]),_c('vs-col',{attrs:{"vs-type":"flex","vs-justify":"flex-end","vs-w":"3"}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }